import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-actions" }
const _hoisted_2 = { class: "left-actions" }
const _hoisted_3 = { id: "app" }
const _hoisted_4 = { class: "sidebar" }
const _hoisted_5 = { class: "main" }
const _hoisted_6 = { class: "sidebarRight" }

import { useStore } from 'vuex';
  import { onMounted } from 'vue';
  import Card from './card.vue';
  import List from './list.vue';
  import Text from './text.vue';
  import Message from './message.vue';
  import right from './right.vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'privatechat',
  emits: ["update:visible"],
  setup(__props, { emit: __emit }) {

  const store = useStore();
  
  const emit = __emit;

  onMounted(() => {
    store.dispatch('initData');
  });


  // 处理关闭
const handleClose = () => {
  emit("update:visible", false);
};

  
return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("返回")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Card),
        _createVNode(List)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Message),
        _createVNode(Text)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(right)
      ])
    ])
  ], 64))
}
}

})